import "./Landing.css";
import { useState } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import {
  Row,
  Image,
  Spacer,
  Text,
  Display,
  Button,
  Page,
  Checkbox,
  Input,
} from "@geist-ui/react";
import { Mail } from "@geist-ui/react-icons";
import { useCookies } from "react-cookie";
import Noter from "../../assets/noter.jpg";

function Landing() {
  const [redirect, setRedirect] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [validStatus, setValidStatus] = useState("default");
  const [newUser, setNewUser] = useState(true);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [cookies, setCookie] = useCookies(["colabAuth"]);

  // const invalidLogin = () => {
  //   setValidStatus("error");
  // };

  if (redirect || cookies.colabAuth) {
    return <Redirect to={redirect} />;
  }

  const login = async () => {
    const details = { username, password };
    const { data, status } = await axios.post(
      "https://eastern-surface-293816.el.r.appspot.com/api/auth/login",
      details
    );

    if (status === 200) {
      setCookie("colabAuth", data, { path: "/" });
      setRedirect("/home");
    }
  };

  const signup = async () => {
    const details = { username, password };
    const { data, status } = await axios.post(
      "https://eastern-surface-293816.el.r.appspot.com/api/auth/create",
      details
    );

    if (status === 200) {
      setCookie("colabAuth", data, { path: "/" });
      setRedirect("/home");
    }
  };

  return (
    <div className="landing">
      <Page size="large" dotBackdrop>
        <Page.Header></Page.Header>
        <Page.Content>
          <Row span={6} justify="center">
            <Text h1 size="6vw">
              Colab
            </Text>
            <Text h1 size="6vw" type="warning">
              orator
            </Text>
          </Row>
          <Text h3>Work on notes together, learn from your peers!</Text>
          <Display width="40vw">
            <Image src={Noter} />
          </Display>
          <Spacer y={1.5} />

          <>
            <Text h3>Welcome back to your after class notes!</Text>
            <Spacer y={1} />
            <form className="main">
              <Input
                icon={<Mail />}
                size="medium"
                status={validStatus}
                name="email"
                type="email"
                placeholder="E-mail"
                onChange={(e) => setUsername(e.target.value)}
              />
              <Spacer y={1} />
              <Input.Password
                size="medium"
                status={validStatus}
                name="password"
                type="password"
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
              />
              <Spacer y={1} />
              <Checkbox
                onChange={() => {
                  setNewUser(!newUser);
                }}
              >
                I don't have an account
              </Checkbox>
              <Spacer y={1} />
              <Button
                auto
                type="warning"
                ghost
                size="medium"
                onClick={(e) => {
                  newUser ? login() : signup();
                }}
              >
                Login
              </Button>
            </form>
          </>

          <Spacer y={1.5} />

          <Text h5 type="secondary">
            Get a summary for best notes for your lecture
          </Text>
          <Text h5 type="secondary">
            QnA platform for all your questions
          </Text>
          <Spacer y={1.5} />
        </Page.Content>
        <Page.Footer>
          By Team Phosphorus
          <Spacer y={1.5} />
        </Page.Footer>
      </Page>
    </div>
  );
}

export default Landing;
